<modal-panel title="Map record to FMS booking" data-testid="comm-recon-edit-record-form-modal" class="modal-panel filter-panel" (close)="OnCancel()">
  <mat-dialog-content [formGroup]="commReconEditRecordForm" class="dialog-content">
    <mat-form-field appearance="outline" class="full">
      <mat-label>Data source</mat-label>
      <mat-select formControlName="dataSourceId" (selectionChange)="onDataSourceChange($event.value)">
        <mat-option *ngFor="let ds of dataSources" [value]="ds.id">{{ ds.displayName}}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full">
      <mat-label>FMS booking (search)</mat-label>

      <input
        type="text"
        matInput
        [placeholder]="commReconEditRecordForm.get('dataSourceId')?.value ? 'Search by Booking Id' : 'Select Data Source first'"
        (input)="onSearchChange($any($event.target).value)"
        formControlName="adxBookingId" 
        [matAutocomplete]="auto"
        [readonly]="!commReconEditRecordForm.get('dataSourceId')?.value"
        [disabled]="!commReconEditRecordForm.get('dataSourceId')?.value"
        />

      <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayBooking">
        <mat-option *ngIf="loadingBookings" disabled>
          <mat-progress-spinner diameter="18" mode="indeterminate"></mat-progress-spinner>
          &nbsp;Searching...
        </mat-option>
        <mat-option *ngFor="let b of (bookingOptions$ | async)" [value]="b">
          {{ b.id }}<span *ngIf="b.vendor?.vendorName"> - {{ b.vendor.vendorName }}</span>
        </mat-option>
        <mat-option *ngIf="searchStarted && (bookingOptions$ | async)?.length === 0 && !(loadingBookings)" disabled>
          No bookings found
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <div *ngIf="searchingError" class="error">{{ searchingError }}</div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button data-testid="comm-recon-edit-record-form-modal-submit-button" type="submit" mat-raised-button (click)="OnSubmit()" color="primary" matTooltip="Confirm" [disabled]="commReconEditRecordForm.invalid">
      <mat-spinner id="delete-vcc-dialog-spinner" color="accent" *ngIf="isLoadingSpinner"diameter="30"></mat-spinner>
      <span *ngIf="!isLoadingSpinner">Submit</span>
    </button>
    <button data-testid="comm-recon-edit-record-form-modal-cancel-button" mat-raised-button (click)="OnCancel()" color="warn" matTooltip="Cancel and Close">
      Cancel
    </button>
  </mat-dialog-actions>
</modal-panel>